import { MediaQuery } from 'svelte/reactivity';

export type BreakpointName = 'mini' | 'small' | 'nav' | 'medium' | 'large' | 'xlarge';

class BreakpointServiceClass {
    /**
     * Mirrors $breakpoints from styles/_defintions.scss.
     * A value changed there has to be changed here too.
     */
    private readonly BaseFont = 16;
    private readonly Breakpoints: Record<BreakpointName, number> = {
        mini: 310,
        small: 480,
        nav: 592,
        medium: 768,
        large: 1024,
        xlarge: 1800,
    };

    /** One instance per size, so every size gets a single matchMedia listener. */
    private readonly Queries: Partial<Record<BreakpointName, MediaQuery>> = {};

    /**
     * Reactive counterpart of the greaterX() mixins, for example greater('large') === @include mixins.greaterLarge().
     * Only use it when CSS alone is not enough — say when a component has to sit elsewhere in the DOM depending on
     * the size instead of just being shown or hidden.
     */
    public greater(name: BreakpointName): MediaQuery {
        return (this.Queries[name] ??= new MediaQuery(this.buildQuery(this.Breakpoints[name])));
    }

    public isGreater(name: BreakpointName): boolean {
        return this.greater(name).current;
    }

    /** Identical to mixins.mediaQueryPixelByPixel() from styles/_mixins.scss. */
    private buildQuery(px: number): string {
        const Rem = px / this.BaseFont;
        return `(min-width: ${Rem.toString()}rem), (min-width: ${px.toString()}px)`;
    }
}

export const BreakpointService = new BreakpointServiceClass();
